import { getCurrentSubcategory } from 'owa-options-store';
import { logUsage } from 'owa-analytics';

const SAVE_DATAPOINT_NAME = 'OptionOnSave';
const DISCARD_DATAPOINT_NAME = 'OptionOnDiscard';

export default function saveOrDiscardOptions(isSave: boolean) {
    return Promise.all(
        getCurrentSubcategory().options.map(option =>
            (async () => {
                let settings = option.fullOptionFormSettings;

                if (settings.isDirty()) {
                    logUsage(isSave ? SAVE_DATAPOINT_NAME : DISCARD_DATAPOINT_NAME, [option.key]);

                    if (isSave) {
                        await settings.onSave();
                    }

                    // We want to "discard" after saving as well, to clean up the view state so it's not stale
                    // if the option is changed outside the full options pane.
                    settings.onDiscard();
                }
            })()
        )
    );
}
